import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer({ minimal = false }) {
  if (minimal) {
    return (
      <footer className="footer footer-minimal">
        <div className="container">
          <div className="footer-minimal-content">
            <p>&copy; {new Date().getFullYear()} checkmycarhistory.com.au - All rights reserved</p>
            <div className="footer-links">
              <Link to="/privacy-policy">Privacy</Link>
              <Link to="/terms-conditions">Terms</Link>
              <Link to="/contact">Contact</Link>
            </div>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col">
            <h4>checkmycarhistory.com.au</h4>
            <p>Official PPSR checks and vehicle history reports. Protecting Australian consumers since 2012.</p>
          </div>
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/report-types">Report Types</Link></li>
              <li><Link to="/help">Help &amp; FAQ</Link></li>
              
            </ul>
          </div>
          <div className="footer-col">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-conditions">Terms &amp; Conditions</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Contact</h4>
            <ul>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><i className="fas fa-clock"></i> Mon-Fri 8:30am-6pm AEST</li>
          </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} checkmycarhistory.com.au - All rights reserved</p>
        </div>
      </div>
    </footer>
  );
}
